import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const newBadgeStyleParts = ['container', 'contentContainer', 'text'] as const

const helpers = createMultiStyleConfigHelpers(newBadgeStyleParts)

export const NewBadgeStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    contentContainer: {
      height: '1.25rem',
      px: '0.25rem',
      alignItems: 'center',
      gap: '0.375rem',
      background: 'gradients.mangoBrand.button',
      userSelect: 'none',
      borderRadius: '0.25rem',
    },
    text: {
      ...textStyles[textStyleKeys.Body4_Bold],
      color: 'brand.contrast',
    },
  },
})

export const useNewBadgeStyles = () =>
  mergeMultiStyleConfig(NewBadgeStyle) as MultiStyleType<
    typeof newBadgeStyleParts
  >
